import { Node } from "slate";

// To HTML
import { Text } from 'slate';

// To plain text
export const toPlainText = (value) => {
  return value.map(n => Node.string(n)).join("\n");
};


export const toHtml = (value) => {
  const escapeHtml = (str) =>
    str.replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  const serialize = (node) => {
    if (Text.isText(node)) {
      let string = escapeHtml(node.text);

      // Inline styles
      const styles = [];
      if (node.color) styles.push(`color: ${node.color}`);
      if (node.background) styles.push(`background-color: ${node.background}`);
      if (node.fontSize) styles.push(`font-size: ${node.fontSize}`);
      let styleAttr = styles.length ? ` style="${styles.join(';')}"` : '';

      // Wrap formatting tags
      if (node.bold) string = `<strong${styleAttr}>${string}</strong>`;
      if (node.italic) string = `<em${styleAttr}>${string}</em>`;
      if (node.underline) string = `<u${styleAttr}>${string}</u>`;
      if (node.strikethrough) string = `<s${styleAttr}>${string}</s>`;
      if (node.code) string = `<code${styleAttr}>${string}</code>`;
      if (node.highlight) string = `<mark${styleAttr}>${string}</mark>`;
      if (node.link && node.url) string = `<a href="${node.url}" target="_blank"${styleAttr}>${string}</a>`;

      // If no formatting, just apply style to <span>
      if (!node.bold && !node.italic && !node.underline && !node.strikethrough && !node.code && !node.highlight && !(node.link && node.url)) {
        if (styleAttr) string = `<span${styleAttr}>${string}</span>`;
      }

      return string;
    }

    const children = node.children?.map(n => serialize(n)).join('') || '';

    switch (node.type) {
    case "paragraph": return `<p>${children}</p>`;
    case "title": return `<h1>${children}</h1>`;
    case "h2": return `<h2>${children}</h2>`;
    case "h3": return `<h3>${children}</h3>`;
    case "video":
      if (!node.url) return '';
      return `<video src="${node.url}" width="${node.width || '100%'}" height="${node.height || 'auto'}" controls></video>`;
      // Add other cases as needed
    default: return `<p>${children}</p>`;
    }
  };

  return value.map(n => serialize(n)).join('');
};



// To Markdown (simplified)
export const toMarkdown = (value) => {
  const serialize = (node) => {
    if (Text.isText(node)) {
      let string = node.text;
      if (node.bold) {
        string = `**${string}**`;
      }
      if (node.italic) {
        string = `*${string}*`;
      }
      if (node.underline) {
        string = `<u>${string}</u>`; // Markdown doesn't natively support underline
      }
      if (node.strikethrough) {
        string = `~~${string}~~`;
      }
      if (node.code) {
        string = `\`${string}\``;
      }
      if (node.link) {
        string = `[${string}](${node.url})`;
      }
      return string;
    }

    const children = node.children.map(n => serialize(n)).join("");

    switch (node.type) {
    case "paragraph":
      return `${children}\n\n`;
    case "block-quote":
      return `> ${children}\n\n`;
    case "bulleted-list":
      return `\n${children}`;
    case "numbered-list":
      return `\n${children}`;
    case "list-item":
      return `- ${children}\n`;
    case "h1":
      return `# ${children}\n\n`;
    case "h2":
      return `## ${children}\n\n`;
    case "h3":
      return `### ${children}\n\n`;
    case "h4":
      return `#### ${children}\n\n`;
    case "h5":
      return `##### ${children}\n\n`;
    case "h6":
      return `###### ${children}\n\n`;
    case "code-block":
      return `\`\`\`\n${children}\n\`\`\`\n\n`;
    case "image":
      return `![image](${node.url})\n\n`;
    case "video":
      return `[Embedded Video](${node.url})\n\n`;
    case "table":
      return `${children}\n\n`;
    case "table-row":
      return `${children}\n`;
    case "table-cell":
      return `| ${children} `;
    default:
      return `${children}\n`;
    }
  };

  return value.map(n => serialize(n)).join("");
};
